import React from 'react'
import EmptyListUI from '../../../widgets/output/EmptyListUI'
import SuperUserPageSF from '../../../templates/SuperUserPageSF.js'
import GenericErrorUI from '../../../components/common/GenericErrorUI'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'
import BankAnalyzerSF from '../../../components/superUser/clientTxn/BankAnalyzerSF'
import ClientTxnCatTransactionListSF from '../../../components/superUser/clientTxn/ClientTxnCatTransactionListSF'
// import './ClientTxnCatTransactionListPage.css'

const ClientTxnCatTransactionListPageUI = ({ context, account, errorList, transactionList,
  onRefreshClick, financialYear, category,
  hasMore, onMoreTransactions, gettingMore,
}) =>
  <SuperUserPageSF context={context} className='pg_su_ct_cat_txn'
    backLink={`/su/accounts/${account ? account.accountId : ''}/clientTxnCats`}
    headerText={`${account ? account.accountName : ''} ${category} transactions`}
    centered={!account || !transactionList}>
    {
      (!account || !transactionList) &&
      <SpinnerComponentUI />
    }
    {
      errorList && errorList.length > 0 &&
      <GenericErrorUI error={errorList[0]} />
    }
    {
      account && transactionList &&
      <BankAnalyzerSF context={context} account={account} show={true}
        onRefreshClick={onRefreshClick}
      />
    }

    <div className='g_m_top_100'>
      {
        transactionList && transactionList.length === 0 &&
        <EmptyListUI
          context={context}
          createDisabledMessageLabel='No transactions'
        />
      }

      {
        transactionList && transactionList.length !== 0 &&
        <ClientTxnCatTransactionListSF
          context={context}
          account={account}
          category={category}

          financialYear={financialYear}
          transactionList={transactionList}
          //
          hasMore={hasMore}
          gettingMore={gettingMore}
          onMoreTransactions={onMoreTransactions}
          //
          onRefreshClick={onRefreshClick}
        />
      }
    </div>
  </SuperUserPageSF>

export default ClientTxnCatTransactionListPageUI
